import ComponentsCatalog from "../../components/ComponentLibrary/ComponentsCatalog";

const ComponentLibraryPage = () => {
  return (
    <div className="w-full page-transition">
      <ComponentsCatalog />
    </div>
  );
};

export default {
  page: ComponentLibraryPage,
};


